import React, {Component} from 'react';
import '../App.css';

class About extends Component{
    //call the constructor method
    constructor(props){
        super(props);
        
        this.state = {
            authFlag : false
        }
    }
    
    componentWillMount(){
        this.setState({
            authFlag : false
        })
    }

    render(){
        return(            
            <div className="modal-login custom-modal about">
                <div className="modal-logo">
                    <img alt="logo" src="/assets/images/logo.png" />
                </div>
                <h2 className="text-center">{this.props.dataLanguage['aboutUs']}</h2>

                <p className="text-center text-yellow">
                    {this.props.dataLanguage['aboutUs_text']}
                </p>
            </div>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/Aboutus.js